module.exports = __webpack_public_path__ + "static/media/Y1.768ca365.jpg";